// extracted by mini-css-extract-plugin
export var danger = "_43-6";
export var lightPink = "_43-a";
export var medium = "_43-j";
export var nearSquare = "_43-m";
export var neutralBlue = "_43-8";
export var neutralYellow = "_43-7";
export var noCapitalize = "_43-1";
export var normal = "_43-2";
export var pill = "_43-0";
export var primary = "_43-3";
export var primaryLight = "_43-4";
export var shadow = "_43-n";
export var small = "_43-k";
export var solidBlack = "_43-i";
export var solidGreen = "_43-d";
export var solidLightBlue = "_43-f";
export var solidNavy = "_43-e";
export var solidOrange = "_43-h";
export var solidPink = "_43-g";
export var solidRed = "_43-b";
export var solidWhite = "_43-9";
export var solidYellow = "_43-c";
export var success = "_43-5";
export var xsmall = "_43-l";